import { render, staticRenderFns } from "./GBPhotoAlbumSlideShow.vue?vue&type=template&id=0e63c88a&"
import script from "./GBPhotoAlbumSlideShow.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumSlideShow.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumSlideShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout,VSpacer})
